export default __webpack_public_path__ + "files/media/private-ar-l.2d83da0f.jpg";